"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAA = getAA;
const aminoAcids_1 = require("./aminoAcids");
function getAA(code) {
    if (code.length === 1) {
        for (let i = 0; i < aminoAcids_1.aminoAcids.length; i++) {
            if (aminoAcids_1.aminoAcids[i].aa1 === code) {
                return aminoAcids_1.aminoAcids[i];
            }
        }
    }
    if (code.length === 3) {
        for (let i = 0; i < aminoAcids_1.aminoAcids.length; i++) {
            if (aminoAcids_1.aminoAcids[i].aa3 === code) {
                return aminoAcids_1.aminoAcids[i];
            }
        }
    }
}
//# sourceMappingURL=getAA.js.map